// extracted by mini-css-extract-plugin
module.exports = {"title":"title-2ePZS","sub":"sub-1v09q","social":"social-2FNxB","email":"email-2VruM","button":"button-1AeEp"};